import React from 'react';

// ============================================================
// ADSENSE CONFIGURATION
// Set ADSENSE_ENABLED to true once you have connected Google AdSense
// ============================================================
const ADSENSE_ENABLED = false;

// AdSense Placeholder Component
// When ADSENSE_ENABLED is false, these components render nothing
// When ADSENSE_ENABLED is true, replace the placeholder content with actual AdSense code

export const AdBanner = ({ size = 'leaderboard', className = '' }) => {
  if (!ADSENSE_ENABLED) return null;
  
  const sizes = {
    leaderboard: { width: '728px', height: '90px', label: '728 x 90' },
    rectangle: { width: '336px', height: '280px', label: '336 x 280' },
    medium: { width: '300px', height: '250px', label: '300 x 250' },
    skyscraper: { width: '160px', height: '600px', label: '160 x 600' },
    responsive: { width: '100%', height: '90px', label: 'Responsive' },
    bottomBar: { width: '100%', height: '60px', label: '100% x 60' }
  };

  const sizeConfig = sizes[size] || sizes.leaderboard;

  // TODO: Replace this placeholder with actual AdSense code:
  // <ins className="adsbygoogle"
  //   style={{ display: 'block', width: sizeConfig.width, height: sizeConfig.height }}
  //   data-ad-client="ca-pub-XXXXXXXXXXXXXXXX"
  //   data-ad-slot="XXXXXXXXXX"
  //   data-ad-format="auto"
  //   data-full-width-responsive="true">
  // </ins>
  
  return (
    <div 
      className={`flex items-center justify-center bg-gray-700 border border-gray-500 ${className}`}
      style={{ 
        width: sizeConfig.width, 
        height: sizeConfig.height,
        maxWidth: '100%',
        backgroundColor: '#4a4a4a'
      }}
    >
      <span className="text-gray-300 text-sm font-medium">
        Ad {sizeConfig.label}
      </span>
    </div>
  );
};

// Sidebar Ad component for vertical placements
export const AdSidebar = ({ className = '' }) => {
  if (!ADSENSE_ENABLED) return null;
  return (
    <div className={`space-y-4 ${className}`}>
      <AdBanner size="rectangle" className="mx-auto" />
    </div>
  );
};

// In-content Ad for placing between sections
export const AdInContent = ({ className = '' }) => {
  if (!ADSENSE_ENABLED) return null;
  return (
    <div className={`my-6 flex justify-center ${className}`}>
      <AdBanner size="responsive" className="w-full max-w-3xl" />
    </div>
  );
};

// Top banner ad
export const AdTopBanner = ({ className = '' }) => {
  if (!ADSENSE_ENABLED) return null;
  return (
    <div className={`mb-4 flex justify-center ${className}`}>
      <AdBanner size="leaderboard" />
    </div>
  );
};

// Bottom banner ad (in-page, not floating)
export const AdBottomBanner = ({ className = '' }) => {
  if (!ADSENSE_ENABLED) return null;
  return (
    <div className={`mt-6 mb-16 flex justify-center ${className}`}>
      <AdBanner size="leaderboard" />
    </div>
  );
};

// Floating Bottom Bar Ad - sticks to bottom of viewport
export const AdFloatingBottomBar = () => {
  if (!ADSENSE_ENABLED) return null;
  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-gray-800 border-t border-gray-600">
      <div className="w-full flex items-center justify-center py-2">
        <div 
          className="flex items-center justify-center bg-gray-700 border border-gray-500"
          style={{ width: '728px', height: '60px', maxWidth: '95%', backgroundColor: '#4a4a4a' }}
        >
          <span className="text-gray-300 text-sm font-medium">
            Ad 728 x 60
          </span>
        </div>
      </div>
    </div>
  );
};

export default AdBanner;
